import { render, staticRenderFns } from "./LinkTabs.vue?vue&type=template&id=ee7fd364&scoped=true&lang=pug&"
import script from "./LinkTabs.vue?vue&type=script&lang=ts&"
export * from "./LinkTabs.vue?vue&type=script&lang=ts&"
import style0 from "./LinkTabs.vue?vue&type=style&index=0&id=ee7fd364&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7fd364",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
